import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormMode, Languages, ServiceStatus } from 'src/app/shared/models/enums.model';
import { FeesEstimate } from 'src/app/front-user/services/e-booking/fees-estimation-request/fees-estimate.model';
import { FeesEstimationAdminDto } from '../../shared/models/fees-estimation-admin.model';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { User } from 'src/app/front-user/shared/models/user.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { FeesEstimationAdminService } from '../../shared/services/fees-estimation-admin.service';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { MeasurementOfficerFeesComponent } from '../measurement-officer-fees/measurement-officer-fees.component';
import { TranslateService } from '@ngx-translate/core';
import { first } from 'rxjs/operators';
import { FeesEstimationService } from 'src/app/front-user/services/e-booking/fees-estimation-request/fees-estimation.service';
import { CustomValidators } from 'src/app/front-user/shipyard-service/models/custom-validator';

@Component({
  selector: 'app-marine-officer-fees',
  templateUrl: './marine-officer-fees.component.html',
  styleUrls: ['./marine-officer-fees.component.css']
})
export class MarineOfficerFeesComponent implements OnInit {

  submitted = false;
  loading = false;
  baseRequestId: string = '';
  marineOfficerForm: FormGroup;
  user: User = new User();
  showRequest = false;
  MeasurmentOffcierObject: FeesEstimationAdminDto = new FeesEstimationAdminDto();
  displayedLang: string;
  requestStatus: number;
  agentId: string;
  //public formMode: FormMode.Readonly;
  public FormMode: any = FormMode;
  public formMode = FormMode.Add;
  feesEstimationObj: FeesEstimate = new FeesEstimate();
  baseRequestDTO: BaseRequest //= new BaseRequest();
  marineRequirements: string;
  measurementObj: FeesEstimate = new FeesEstimate();
  @Input() public isShow: boolean = true;
  // @Output() marineLoaded = new EventEmitter<boolean>();
  @ViewChild('measurementRequest',{static: false}) measurementRequest: MeasurementOfficerFeesComponent;
  isErrorMessage: boolean = false;
  showMraineRequirments: boolean = true;
  lockTaskErrorMessage: boolean= false;

  constructor(private formBuilder: FormBuilder,
    private globalSrv: GlobalServices,
    private route: ActivatedRoute, private router: Router,
    private authenticationService: AuthenticationService, private alertService: AlertService,
    private feesSrv: FeesEstimationAdminService, private feesEstimationService: FeesEstimationService, private translate: TranslateService, private baseRequestService: BaseRequestService, ) {
    //this.baseRequestId = this.route.snapshot.params.Id;
    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;
      this.getBaseRequest();
    }else{
      window.history.back();
    }
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    this.user = this.globalSrv.user;

  }

  ngOnInit() {


    this.buildForm();


  }

  get f() {
    return this.marineOfficerForm.controls;
  }
  // receiveMeasurement(loaded: boolean) {
  //   if (loaded) {
  //     this.measurementObj.FeeValue = this.measurementRequest.measurementOfficerForm.controls.FeeValue.value;
  //     this.measurementObj.InsuranceValue = this.measurementRequest.measurementOfficerForm.controls.InsuranceValue.value;

  //   }
  // }

  // onChangeRequirements(event) {
  //   this.marineRequirements = event.target.value;
  // }
  buildForm() {
    this.marineOfficerForm = this.formBuilder.group({
      MarineRequirements: new FormControl('', [Validators.required]),
    });
  }


  getBaseRequest() {
    this.feesEstimationService.get(this.baseRequestId).pipe(first()).subscribe(
      d => {
        if (d.Success) {
          this.feesEstimationObj = d.Data;
          this.requestStatus = this.feesEstimationObj.StatusId;
          this.agentId = this.feesEstimationObj.RequestorId;
          if (history.state.data && history.state.data.isCompleted) {
            if (!this.feesEstimationObj.MarineRequirements) {
              this.showMraineRequirments = false;
            }
            this.formMode = FormMode.Readonly;
            this.marineOfficerForm.patchValue({
              MarineRequirements: this.feesEstimationObj.MarineRequirements,
            });
            this.marineOfficerForm.disable();
          }
          else if (this.requestStatus == ServiceStatus.PendingonMarineNavigationOfficerApproval) {
            this.formMode = FormMode.Add;
            this.marineOfficerForm.enable();
          }
          else {
            this.formMode = FormMode.Readonly;
            if (this.requestStatus == ServiceStatus.PendingonMeasurementsDepartmentManagerApproval) {
              if (!this.feesEstimationObj.MarineRequirements) {
                this.showMraineRequirments = false;
              }
              this.marineOfficerForm.enable();
            } else {
              this.marineOfficerForm.disable();
            }
            this.marineOfficerForm.patchValue({
              MarineRequirements: this.feesEstimationObj.MarineRequirements,
            });
          }
          //this.marineLoaded.emit(true);
        }

      }
    )
  }
  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.marineOfficerForm.invalid) {
      return;
    } this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;
    this.MeasurmentOffcierObject = this.marineOfficerForm.value;
    this.MeasurmentOffcierObject.AdminEmail = this.user.UserName;
    this.MeasurmentOffcierObject.RequestId = this.baseRequestId;

    this.feesSrv.fillMarineFees(this.MeasurmentOffcierObject)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            //this.alertService.success('Decision Submitted Successfully', false);
            this.marineOfficerForm.reset();
            this.loading = false;
            this.showRequest = true;
            this.isErrorMessage = false;
          }
          else if(data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser")!=null){
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
           else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            // this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.'+data.ErrorMessages[0]), false);

            this.loading = false;
          }

        });
  }

}
